import { Component, OnInit } from '@angular/core';
import { Message} from 'primeng/primeng';
import { ConfirmationService} from 'primeng/primeng';
import { SelectItem} from 'primeng/primeng';
import { AddressService} from '../services/address.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {

  msgs: Message[] = [];
  totalRecords:number;
  address: any;
  addresses : any [];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;
  optionsAdd: any;
  optionsEdit: any;
  overlaysAdd: any[];
  overlaysEdit: any[];
  mapAdd: google.maps.Map =null;
  mapEdit: google.maps.Map =null;
  markerAdd: google.maps.Marker;
  markerEdit: google.maps.Marker;

  constructor(private addressService:AddressService, private confirmationService: ConfirmationService) { }
  ngOnInit() {

    this.optionsAdd = {
      zoom: 6
    };
    this.optionsEdit = {
      zoom: 13
    };
    this.init();
    this.status = [
      {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
      {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
    ];
  }

  init(){
    this.overlaysAdd=[];
    this.overlaysEdit=[];
    this.markerAdd = null;
    this.markerEdit = null;
    this.blockedDocument = true;
    this.addresses = [];
    this.addressService.findAll().then(data => {
      let response: any = data;
      response.addresses.forEach(item => {
        this.addresses.push(item);
      });

      this.totalRecords = this.addresses.length;
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
    this.address = {};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
    setTimeout(()=> { // map will need some time to load
      if(this.mapAdd!=null){
        this.mapAdd.setCenter(new google.maps.LatLng(-17, -65));
        this.mapAdd.setZoom(6);
      }
    }, 1000);
  }

  showEdit(address:any){
    this.overlaysEdit= [];
    this.address=address;
    this.markerEdit = new google.maps.Marker({position: new google.maps.LatLng(this.address.latitude,this.address.longitude),draggable: true});
    this.overlaysEdit.push(this.markerEdit);
    this.displayEdit = true;

    setTimeout(()=> { // map will need some time to load
      if(this.mapEdit!=null){
        this.mapEdit.setCenter(new google.maps.LatLng(this.address.latitude,this.address.longitude));
        this.mapEdit.setZoom(13);
      }
    }, 500);
  }

  hide(){
    this.address = {};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  add(){
    this.blockedDocument = true;
    this.address.latitude = this.markerAdd.getPosition().lat();
    this.address.longitude = this.markerAdd.getPosition().lng();
    this.addressService.create(this.address).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.address.latitude = this.markerEdit.getPosition().lat();
    this.address.longitude = this.markerEdit.getPosition().lng();
    this.addressService.edit(this.address).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar el registro seleccionado?',
      header: 'Confirmación',
      icon: 'fa fa-trash',
      accept: () => {
        this.blockedDocument = true;
        this.addressService.remove(id).then(data =>{
          let response: any = data;
          if(response.status == 'OK'){
            this.init();
            this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
        }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
          this.blockedDocument = false;
        });
      }
    });
  }

  setMapAdd(event) {
    this.mapAdd = event.map;
    this.mapAdd.setCenter(new google.maps.LatLng(-17, -65));
    this.mapAdd.setZoom(6);

  }

  setMapEdit(event) {
    this.mapEdit = event.map;
    if(this.address.latitude !=null && this.address.longitude !=null){
      this.mapEdit.setCenter(new google.maps.LatLng(this.address.latitude,this.address.longitude));
      this.mapEdit.setZoom(13);
    }

  }

  handleMapClickAdd(event) {
    this.overlaysAdd=[];
    this.markerAdd = new google.maps.Marker({position: event.latLng,draggable: true});
    this.overlaysAdd.push(this.markerAdd);
  }

  handleMapClickEdit(event) {
    this.overlaysEdit=[];
    this.markerEdit = new google.maps.Marker({position: event.latLng,draggable: true});
    this.overlaysEdit.push(this.markerEdit);
  }

  isValidMarker(){
    return this.markerAdd != null;
  }

}



// WEBPACK FOOTER //
// ./src/app/address/address.component.ts